import { Box, Flex, Stack, Text } from '@chakra-ui/core'
import React from 'react'
import { BodyField } from '../fileds/BodyField'
import { PopRecipients } from '../fileds/PopRecipients'
import { PopSwitch } from '../fileds/PopSwitch'
import { PushMessageField } from '../fileds/PushMessageField'
import { PushTitleField } from '../fileds/PushTitleField'
import { Controller, useFormContext } from 'react-hook-form'
import { PopType } from 'components/Pop/types'
import useLocaleText from 'components/useLocaleText'

export const PopGPT = () => {
  const { control } = useFormContext()
  const select_audience = useLocaleText('select_audience', true)
  const enable_push_notification = useLocaleText('enable_push_notification', true)

  return (
    <Stack style={{ gap: '15px' }} mt={4}>
      <BodyField keyName="data.pop_body" label="pop_body" placeholder="pop_body_placeholder" />

      <Box>
        <Text fontSize="14px" fontWeight="bold" color="gray.500" mb={2}>
          {select_audience}
        </Text>
        <PopRecipients />
      </Box>

      <Flex flexDir="column" mt={2} w={{ base: '100%', md: 'calc(50% - 10px)' }}>
        <Flex alignItems="center" justifyContent="space-between">
          <Text fontSize="14px" fontWeight="bold" color="gray.500" mb={2} w="100%">
            {enable_push_notification}
          </Text>
          <PopSwitch name="is_send_push_notification" />
        </Flex>

        <PushTitleField
          keyName="data.push_title"
          label="push_title"
          placeholder="push_title_placeholder"
          keySwitch="is_send_push_notification"
        />
        <PushMessageField
          keyName="data.push_body"
          label="push_body"
          placeholder="push_body_placeholder"
          keySwitch="is_send_push_notification"
        />
      </Flex>
      <Controller name="pop_type" control={control} defaultValue={PopType.ChatGpt} as={<Box display="none" />} />
      <Controller name="rid" control={control} as={<Box display="none" />} />
    </Stack>
  )
}
